import { QueryKeys } from "@/constants";
import { emitEvent, EventConstants } from "@/lib/event-emitter";
import { ErrorNotificationType } from "@/pages/components/error-notification";
import httpClient from "@/services";
import { useMutation } from "@tanstack/react-query";
import type { AxiosError } from "axios";

export type IUpdateAccountInfoPayload = {
  email?: string;
  phone?: string;
  firstname?: string;
  lastname?: string;
  groupId?: string;
  memberId?: string;
  password?: string;
  username?: string;
  accessToken?: string;
  divisionId?: string;
  signature?: string;
};

export type IUpdateAccountInfoResponse = {
  expiryTimestamp: string;
  message: string;
  signature: string;
  success: boolean;
  status: string;
  createdTimestamp: string;
};

export type IUpdateAccountOtpPayload = {
  email: string;
  enteredOTP: string;
  firstname: string;
  groupId: string;
  lastname: string;
  memberId: string;
  phone: string;
  username: string;
  accessToken?: string;
  signature: string;
};

export type IUpdateAccountOtpResponse = {
  message: string;
  success: boolean;
  status: string;
};

export const updateProfileInfo = async (info: IUpdateAccountInfoPayload) => {
  const params = {
    email: info.email,
    phone: info.phone,
    firstname: info.firstname,
    lastname: info.lastname,
    groupId: info.groupId,
    memberId: info.memberId,
    password: info.password,
    username: info.username,
  };
  const config = {
    method: "POST",
    maxBodyLength: Infinity,
    url: "profile/updateProfile",
    headers: {
      Authorization: `Bearer ${info.accessToken}`,
      "Content-Type": "application/json",
      "Accept-Version": "3.0",
    },
    data: params,
  };

  return httpClient.request(config).then((response) => response.data);
};

export const useMUpdateAccountInfo = () => {
  return useMutation({
    mutationFn: (updateAccountInfoResponse: IUpdateAccountInfoPayload) => {
      return updateProfileInfo(updateAccountInfoResponse);
    },
    mutationKey: [QueryKeys.UPDATE_ACCOUNT_INFO],
  });
};

export const updateAccountOtp = async (info: IUpdateAccountOtpPayload) => {
  const params = {
    email: info.email,
    phone: info.phone,
    firstname: info.firstname,
    lastname: info.lastname,
    groupId: info.groupId,
    memberId: info.memberId,
    enteredOTP: info.enteredOTP,
    username: info.username,
  };
  const config = {
    method: "POST",
    maxBodyLength: Infinity,
    url: "otp/updateProfile",
    headers: {
      Authorization: `Bearer ${info.accessToken}`,
      "Content-Type": "application/json",
      "Accept-Version": "3.0",
      Signature: info.signature,
    },
    data: params,
  };

  return httpClient.request(config).then((response) => response.data);
};

export const useMUpdateAccountOtp = () => {
  return useMutation({
    mutationFn: (updateAccountInfoResponse: IUpdateAccountOtpPayload) => {
      return updateAccountOtp(updateAccountInfoResponse);
    },
    mutationKey: [QueryKeys.UPDATE_ACCOUNT_OTP],

    onSuccess: (data: IUpdateAccountOtpResponse) => {
      if (!data.success) {
        emitEvent(EventConstants.ADD_ERROR, {
          message: data.message,
          type: ErrorNotificationType.ERROR,
        });
      }
    },
    onError: (error: AxiosError) => {
      emitEvent(EventConstants.ADD_ERROR, {
        message: error.message,
        type: ErrorNotificationType.ERROR,
      });
    },
  });
};
